export const calculateDropdownPositionTop = (inputEl?: HTMLElement | null, dropdownEl?: HTMLElement | null): number => {
    if (!inputEl || !dropdownEl) {
        return 0;
    }

    const { top: inputTop = 0, bottom: inputBottom = 0 } = inputEl.getBoundingClientRect() || {};
    const { top: dropdownTop = 0, bottom: dropdownBottom = 0 } = dropdownEl.getBoundingClientRect() || {};
    const inputHeight = inputBottom - inputTop;
    const dropdownHeight = dropdownBottom - dropdownTop;
    const gap = 4;
    const windowHeight = window.innerHeight || document.documentElement.clientHeight;
    const freeSpaceToWindowTop = inputTop - gap;
    const freeSpaceToWindowBottom = windowHeight - inputBottom - gap;

    return freeSpaceToWindowBottom >= dropdownHeight || freeSpaceToWindowBottom > freeSpaceToWindowTop
        ? inputHeight + gap
        : -(dropdownHeight + gap);
};
